import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { createProfile, getProfile, updateProfile } from '../../Services/userProfile';


const Profile = () => {

    const [formData, setFormData] = useState({
        userId: '',
        firstName: '',
        middleName: '',
        lastName: '',
        dob: '',
        mobile: '',
        email: '',
        aadharcard: '',
        pancard: '',
        address: '',
        pincode: '',
        createdBy: '',
    });
    const navigate = useNavigate();

    const [profileImage, setProfileImage] = useState(null);
    const [profileImagePreview, setProfileImagePreview] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [isEditable, setIsEditable] = useState(false);
    const [isProfileFound, setIsProfileFound] = useState(false);

    // Fetch user profile on component mount
    useEffect(() => {
        if (success) {
            // Use Bootstrap's modal API to show the modal
            const modalElement = document.getElementById("success-alert-modal");
            const bootstrapModal = new window.bootstrap.Modal(modalElement);
            bootstrapModal.show();

            // Automatically close the modal after 3 seconds
            setTimeout(() => {
                bootstrapModal.hide();
                navigate('/login');
                setSuccess(false); // Reset success state after hiding the modal
            }, 2000);
        }

        if (error) {
            // Use Bootstrap's modal API to show the modal
            const modalElement = document.getElementById("warning-alert-modal");
            const bootstrapModal = new window.bootstrap.Modal(modalElement);
            bootstrapModal.show();

            // Automatically close the modal after 3 seconds
            setTimeout(() => {
                bootstrapModal.hide();
                setError(false); // Reset success state after hiding the modal
            }, 2000);
        }


        const fetchProfile = async () => {
            const user = JSON.parse(localStorage.getItem('user'));
            if (user) {
                setFormData((prevData) => ({
                    ...prevData,
                    userId: user.id,
                    createdBy: user.id,
                }));
                try {
                    const profile = await getProfile(user.id);
                    if (profile) {
                        if (profile.dob) {
                            profile.dob = profile.dob.split('T')[0];
                        }
                        setFormData((prevData) => ({
                            ...prevData,
                            ...profile,
                        }));
                        if (profile.profileImage) {
                            setProfileImage(profile.profileImage); // Load profile image preview
                        }
                        setIsProfileFound(true);
                        setIsEditable(false);
                    } else {
                        setIsProfileFound(false);
                        setIsEditable(true);
                    }
                } catch (error) {
                    //console.error('Error fetching profile:', error);
                    setIsProfileFound(false);
                    setIsEditable(true); // Allow editing if there's an error
                }
            }
        };
        fetchProfile();
    }, [success, error, navigate]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setProfileImage(file);

            const reader = new FileReader();
            reader.onload = () => setProfileImagePreview(reader.result);
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = new FormData();
        Object.keys(formData).forEach((key) => {
            if (formData[key]) form.append(key, formData[key]);
        });

        // If a new image is selected, append it to the form
        if (profileImage) {
            form.append('profileImage', profileImage); // New image
        }

        try {
            if (isProfileFound) {
                if (profileImage) {
                    await updateProfile(formData.userId, form);
                    setSuccess('Your profile has been successfully updated! Please Re-Login');

                } else {
                    setError('Please select profile picture!');
                }
            } else {
                await createProfile(form);
                setSuccess('Your profile has been successfully inserted! Please Re-Login');
                setIsProfileFound(true);
                setIsEditable(false);
            }
            setIsEditable(false);

            // Optionally reset profileImage state if update succeeds
            if (profileImage) {
                setProfileImage(null);
            }
        } catch (error) {
            setError('');
            setSuccess('');
        }
    };

    const handleUpdateClick = (e) => {
        e.preventDefault();
        setIsEditable(true);
    };

    const handleCancelClick = (e) => {
        e.preventDefault();
        setIsEditable(false);
    };
    return (
        <>
            <div className="wrapper">
                <div className="content-page">
                    <div className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box">
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item">
                                                    <Link to="/dashboard">
                                                        Dashboard
                                                    </Link>
                                                </li>
                                                <li className="breadcrumb-item active">Personal Details</li>
                                            </ol>
                                        </div>
                                        <h4 className="page-title">User Details</h4>
                                    </div>
                                </div>
                            </div>


                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <h4 className="header-title">Personal Details</h4>
                                            {error &&
                                                <div id="warning-alert-modal" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true">
                                                    <div className="modal-dialog modal-sm">
                                                        <div className="modal-content">
                                                            <div className="modal-body p-4">
                                                                <div className="text-center">
                                                                    <i className="ri-alert-line h1 text-warning" />
                                                                    <h4 className="mt-2">Incorrect Information</h4>
                                                                    <p className="mt-3">{error}</p>
                                                                    <button type="button" className="btn btn-warning my-2" data-bs-dismiss="modal">Continue</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {success && (
                                                <div id="success-alert-modal" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true">
                                                    <div className="modal-dialog modal-sm">
                                                        <div className="modal-content modal-filled bg-success">
                                                            <div className="modal-body p-4">
                                                                <div className="text-center">
                                                                    <i className="ri-check-line h1" />
                                                                    <h4 className="mt-2">Well Done!</h4>
                                                                    <p className="mt-3">{success}</p>
                                                                    <button type="button" className="btn btn-light my-2" data-bs-dismiss="modal" onClick={() => navigate("/login")} >Continue</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            <hr /><hr />
                                            <div className="tab-content">
                                                <div className="tab-pane show active" id="input-types-preview">
                                                    <div className="row">
                                                        <form onSubmit={(e) => e.preventDefault()}>
                                                            <div className="row">
                                                                {/* First Name, Middle Name, Last Name */}
                                                                <div className="col-md-4 mb-3">
                                                                    <label htmlFor="firstName" className="form-label">First Name</label>
                                                                    <input
                                                                        type="text"
                                                                        id="firstName"
                                                                        name="firstName"
                                                                        className="form-control"
                                                                        value={formData.firstName}
                                                                        onChange={handleChange}
                                                                        readOnly={!isEditable}
                                                                    />
                                                                </div>
                                                                <div className="col-md-4 mb-3">
                                                                    <label htmlFor="middleName" className="form-label">Middle Name</label>
                                                                    <input
                                                                        type="text"
                                                                        id="middleName"
                                                                        name="middleName"
                                                                        className="form-control"
                                                                        value={formData.middleName}
                                                                        onChange={handleChange}
                                                                        readOnly={!isEditable}
                                                                    />
                                                                </div>
                                                                <div className="col-md-4 mb-3">
                                                                    <label htmlFor="lastName" className="form-label">Last Name</label>
                                                                    <input
                                                                        type="text"
                                                                        id="lastName"
                                                                        name="lastName"
                                                                        className="form-control"
                                                                        value={formData.lastName}
                                                                        onChange={handleChange}
                                                                        readOnly={!isEditable}
                                                                    />
                                                                </div>

                                                                {/* Date of Birth, mobile, email */}
                                                                <div className="col-md-3 mb-3">
                                                                    <label htmlFor="dob" className="form-label">Date of Birth</label>
                                                                    <input
                                                                        type="date"
                                                                        id="dob"
                                                                        name="dob"
                                                                        className="form-control"
                                                                        value={formData.dob}
                                                                        onChange={handleChange}
                                                                        readOnly={!isEditable}
                                                                    />
                                                                </div>
                                                                <div className="col-md-2 mb-3">
                                                                    <label htmlFor="gender" className="form-label">Gender</label>
                                                                    <select
                                                                        id="gender"
                                                                        name="Gender"
                                                                        className="form-select"
                                                                        value={formData.Gender}
                                                                        onChange={handleChange}
                                                                        readOnly={!isEditable}
                                                                    >
                                                                        <option value="">Select</option>
                                                                        <option value="male">Male</option>
                                                                        <option value="female">Female</option>
                                                                        <option value="other">Other</option>
                                                                    </select>
                                                                </div>
                                                                <div className="col-md-3 mb-3">
                                                                    <label htmlFor="mobile" className="form-label">Mobile No</label>
                                                                    <input
                                                                        type="tel"
                                                                        id="mobile"
                                                                        name="mobile"
                                                                        className="form-control"
                                                                        value={formData.mobile}
                                                                        onChange={handleChange}
                                                                        readOnly={!isEditable}
                                                                    />
                                                                </div>
                                                                <div className="col-md-4 mb-3">
                                                                    <label htmlFor="email" className="form-label">Email</label>
                                                                    <input
                                                                        type="email"
                                                                        id="email"
                                                                        name="email"
                                                                        className="form-control"
                                                                        value={formData.email}
                                                                        onChange={handleChange}
                                                                        readOnly={!isEditable}
                                                                    />
                                                                </div>

                                                                {/* Aadhar, PAN, Profile Picture */}
                                                                <div className="col-md-4 mb-3">
                                                                    <label htmlFor="aadhar" className="form-label">Aadhar Card No</label>
                                                                    <input
                                                                        type="text"
                                                                        id="aadhar"
                                                                        name="aadharcard"
                                                                        className="form-control"
                                                                        value={formData.aadharcard}
                                                                        onChange={handleChange}
                                                                        readOnly={!isEditable}
                                                                    />
                                                                </div>
                                                                <div className="col-md-4 mb-3">
                                                                    <label htmlFor="pan" className="form-label">PAN Card No</label>
                                                                    <input
                                                                        type="text"
                                                                        id="pan"
                                                                        name="pancard"
                                                                        className="form-control"
                                                                        value={formData.pancard}
                                                                        onChange={handleChange}
                                                                        readOnly={!isEditable}
                                                                    />
                                                                </div>
                                                                <div className="col-md-4 mb-3">
                                                                    <label htmlFor="qualification" className="form-label">Qualification</label>
                                                                    <input
                                                                        type="text"
                                                                        id="qualification"
                                                                        name="Qualification"
                                                                        className="form-control"
                                                                        value={formData.Qualification}
                                                                        onChange={handleChange}
                                                                        readOnly={!isEditable}
                                                                    />
                                                                </div>
                                                                {/* address in full width */}
                                                                <div className="col-12 mb-3">
                                                                    <label htmlFor="address" className="form-label">Address</label>
                                                                    <textarea
                                                                        id="address"
                                                                        name="address"
                                                                        className="form-control"
                                                                        rows="5"
                                                                        value={formData.address}
                                                                        onChange={handleChange}
                                                                        readOnly={!isEditable}
                                                                    ></textarea>
                                                                </div>
                                                                {/* pincode in full width */}
                                                                <div className="col-md-4 mb-3">
                                                                    <label htmlFor="pincode" className="form-label">Pincode</label>
                                                                    <input
                                                                        type="text"
                                                                        id="pincode"
                                                                        name="pincode"
                                                                        className="form-control"
                                                                        value={formData.pincode}
                                                                        onChange={handleChange}
                                                                        readOnly={!isEditable}
                                                                    />
                                                                </div>

                                                                <div className="col-md-4 mb-3">
                                                                    <label htmlFor="profilePicture" className="form-label">Profile Picture</label>
                                                                    <input
                                                                        type="file"
                                                                        id="profileImage"
                                                                        name="profileImage"
                                                                        className="form-control"
                                                                        onChange={handleFileChange}
                                                                        disabled={!isEditable}   // ✅ correct
                                                                        accept="image/*"
                                                                    />

                                                                </div>
                                                                <div className="col-md-1 mb-3">
                                                                    {(profileImagePreview || profileImage) && (
                                                                        <img
                                                                            src={
                                                                                profileImagePreview
                                                                                    ? profileImagePreview                      // newly selected image
                                                                                    : typeof profileImage === "string"
                                                                                        ? `https://api.mysfs24.com/${profileImage.replace(/^(\.\.\/)+/, '')}` // backend image
                                                                                        : ""
                                                                            }
                                                                            alt="Profile Preview"
                                                                            className="rounded-profile-img mt-3"
                                                                            style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                                                                        />
                                                                    )}

                                                                </div>

                                                                {/* Button Group */}
                                                                <div className="d-flex flex-wrap gap-2">
                                                                    {!isProfileFound ? (
                                                                        <button type="button" className="btn btn-primary" onClick={handleSubmit}>
                                                                            Submit
                                                                        </button>
                                                                    ) : !isEditable ? (
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-info"
                                                                            onClick={handleUpdateClick}
                                                                        >
                                                                            Update
                                                                        </button>
                                                                    ) : (
                                                                        <>
                                                                            <button type="button" className="btn btn-success" onClick={handleSubmit}>
                                                                                Save Changes
                                                                            </button>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-danger"
                                                                                onClick={handleCancelClick}
                                                                            >
                                                                                Cancel
                                                                            </button>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </div> {/* end col */}
                                                </div>
                                            </div> {/* end preview*/}
                                        </div> {/* end tab-content*/}
                                    </div> {/* end card-body */}
                                </div> {/* end card */}
                            </div>{/* end col */}
                        </div>{/* end row */}
                    </div>
                </div>
            </div>
        </>
    )
}

export default Profile
